/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:7b3b5a84-93eb-498c-9e46-421a6666a62a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_y9jVMJMze",
    "aws_user_pools_web_client_id": "1u2969dlga5uvruimkclp63dfo",
    "oauth": {
        "domain": "us-east-1y9jvmjmze.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "https://4028-firebase-cosmgit-1752758438389.cluster-axf5tvtfjjfekvhwxwkkkzsk2y.cloudworkstations.dev/auth,https://cosmelytix.com/,https://d84l1y8p4kdic.cloudfront.net/,https://us-east-1y9jvmjmze.auth.us-east-1.amazoncognito.com/oauth2/idpresponse",
        "redirectSignOut": "https://4028-firebase-cosmgit-1752758438389.cluster-axf5tvtfjjfekvhwxwkkkzsk2y.cloudworkstations.dev/auth,https://cosmelytix.com/https://",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
